/* eslint-disable react/jsx-no-useless-fragment */

import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import { strategyTargetGroupLabels } from "../../../../../../../label/activity";

import { Checkboxes, Option } from "../../../../../../../react-components/lu-component/src/index";
import { AccordionForm } from "../../../../parts/accodion-form";
import { beautySupplementCategoryOptions, StrategyGroup } from "../../../../../../../server/models/activity";

type Props = {
	onChange: (name: keyof StrategyGroup, value: any) => void;
	strategyGroup: StrategyGroup;
};

export const BeautySupplementCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;

	const shouldShow = React.useMemo(
		() => strategyGroup.category?.some((c) => c.category.type === "beauty-supplement"),
		[strategyGroup.category],
	);

	return (
		<Row>
			<FormGroup as={Col} md={5}>
				<AccordionForm
					defaultShow={
						strategyGroup.beautySupplementCategory != null && 0 < strategyGroup.beautySupplementCategory.length
					}
					eventKey="beautySupplementCategory"
					title={strategyTargetGroupLabels.beautySupplementCategory ?? ""}
				>
					{shouldShow ? (
						<Checkboxes
							checkeds={strategyGroup.beautySupplementCategory ?? []}
							choices={beautySupplementCategoryOptions as Option[]}
							name="beautySupplementCategory"
							onChange={(value) => {
								onChange("beautySupplementCategory", value);
							}}
						/>
					) : (
						<></>
					)}
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
